import alterConfig from '@apps/maha/services/mjson/alter_config'
import PropTypes from 'prop-types'
import Pasteur from 'pasteur'
import React from 'react'

class Canvas extends React.PureComponent {

  static contextTypes = {
    confirm: PropTypes.object,
    provider: PropTypes.object
  }

  static propTypes = {
    config: PropTypes.object,
    version: PropTypes.object
  }

  iframeRef = React.createRef()

  _handleRender = this._handleRender.bind(this)

  render() {
    return (
      <div className="maha-signup-page-designer-canvas">
        <iframe { ...this._getIFrame() } />
      </div>
    )
  }

  componentDidMount() {
    this.pasteur = new Pasteur({
      window,
      target: this.iframeRef.current.contentWindow,
      name: 'mDesigner',
      targetName: 'mRenderer'
    })
    this.pasteur.on('ready', this._handleRender)
  }

  componentDidUpdate(prevProps) {
    const { config } = this.props
    if(!_.isEqual(config, prevProps.config)) {
      this._handleRender()
    }
  }

  componentWillUnmount() {
    this.pasteur.close()
  }

  _getConfig() {
    const { name, message, headshot } = this.props.config
    const { version } = this.props
    return alterConfig(version.value, (config) => {
      if(headshot && config?.id === 'u5a4s') {
        config.content.alt = name
        config.content.image = headshot
        return config
      } else if(!headshot && config?.[0]?.id === 'bmjsc') {
        config = config.slice(1)
        return config
      } else if(config?.id === 'liu14') {
        config.content.text = `<p><strong>${name || 'Your Name Here'}</strong></p>`
        return config
      } else if(config?.id === 'uix5r') {
        config.content.text = message || '<p>Type a personal message her</p>'
        return config
      }
      return null
    })
  }

  _getIFrame() {
    return {
      ref: this.iframeRef,
      src: '/renderers/mjson/page'
    }
  }

  _handleRender() {
    const { provider } = this.context
    this.pasteur.send('update', {
      active: null,
      config: this._getConfig(),
      darkMode: false,
      domain: provider,
      editable: false,
      hover: null,
      images: true
    })
  }

}

export default Canvas
